import { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../components/Loader'
import { useLoginMutation } from '../slices/usersApiSlice'
import { setCredentials } from '../slices/authSlice'
import { toast } from "sonner"

const LoginScreen = () => {
    const [ email, setEmail ] = useState('')
    const [ password, setPassword ] = useState('')
    const [showVerifyCta, setShowVerifyCta] = useState(false)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [login, { isLoading } ] = useLoginMutation()

    const { userInfo } = useSelector((state) => state.auth )

    const { search } = useLocation()

    const sp = new URLSearchParams(search)
    const redirect = sp.get('redirect') || '/'

    useEffect(() => {
        if (userInfo)  {
            navigate(redirect)
        }
    }, [userInfo, redirect, navigate])

    const submitHandler = async (e) => {
        e.preventDefault()
        setShowVerifyCta(false)
        try {
            const res = await login({ email, password }).unwrap()
            dispatch(setCredentials({...res, }))
            navigate(redirect)
        } catch (err) {
            const message = err?.data?.message || err.error || 'Sign in failed'
            toast.error(message)
            if (/verify your email/i.test(message)) {
                setShowVerifyCta(true)
            }
        }
    }


    return (
        <section className='mx-auto w-full max-w-md'>
            <div className='rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8'>
                <p className='mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-sky-700'>
                    Account
                </p>
                <h1 className='mb-2 text-3xl font-semibold text-slate-900'>Sign In</h1>

                <form onSubmit={submitHandler} className='space-y-4'>
                    <div>
                        <label htmlFor='email' className='mb-1.5 block text-sm font-medium text-slate-700'>
                            Email Address
                        </label>
                        <input
                            id='email'
                            type='email'
                            placeholder='Enter email'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className='w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm text-slate-800 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-2 focus:ring-sky-100'
                        />
                    </div>

                    <div>
                        <label htmlFor='password' className='mb-1.5 block text-sm font-medium text-slate-700'>
                            Password
                        </label>
                        <input
                            id='password'
                            type='password'
                            placeholder='Enter password'
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className='w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm text-slate-800 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-2 focus:ring-sky-100'
                        />
                        <div className='mt-2'>
                            <Link
                                to='/forgot-password'
                                className='text-xs font-semibold text-sky-700 no-underline hover:text-sky-800'
                            >
                                Forgot password?
                            </Link>
                        </div>
                    </div>

                    <button
                        type='submit'
                        disabled={isLoading}
                        className='inline-flex items-center justify-center rounded-xl bg-sky-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-sky-700 disabled:cursor-not-allowed disabled:bg-slate-300'
                    >
                        Sign In
                    </button>

                    {isLoading && <Loader />}
                </form>

                <p className='mt-5 text-sm text-slate-600'>
                    New Customer?{' '}
                    <Link
                        to={redirect ? `/register?redirect=${redirect}` : '/register'}
                        className='font-semibold text-sky-700 no-underline hover:text-sky-800'
                    >
                        Register
                    </Link>
                </p>
                {showVerifyCta ? (
                    <p className='mt-2 text-sm text-amber-700'>
                        Email not verified.{' '}
                        <Link
                            to={`/verify-email/notice?email=${encodeURIComponent((email || '').trim().toLowerCase())}`}
                            className='font-semibold text-sky-700 no-underline hover:text-sky-800'
                        >
                            Verify email
                        </Link>
                    </p>
                ) : null}
            </div>
        </section>
    )
}

export default LoginScreen


